"use client";

import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Facebook, Instagram, Linkedin, Twitter } from "lucide-react";
export default function PiedDePage() {
  const {
    ref: col1Ref,
    isVisible: col1Visible
  } = useRevealOnScroll({
    threshold: 0.3
  });
  const {
    ref: col2Ref,
    isVisible: col2Visible
  } = useRevealOnScroll({
    threshold: 0.3
  });
  const {
    ref: col3Ref,
    isVisible: col3Visible
  } = useRevealOnScroll({
    threshold: 0.3
  });
  const servicesLinks = [{
    label: "Rénovation intérieure",
    href: "/NosServicesPage"
  }, {
    label: "Rénovation extérieure",
    href: "/NosServicesPage"
  }, {
    label: "Petits travaux",
    href: "/NosServicesPage"
  }, {
    label: "Performance énergétique",
    href: "/NosServicesPage"
  }, {
    label: "Chauffage & Climatisation",
    href: "/NosServicesPage"
  }, {
    label: "Énergies renouvelables",
    href: "/NosServicesPage"
  }];
  const aidesLinks = [{
    label: "MaPrimeRénov'",
    href: "/AidesFinancieresPage"
  }, {
    label: "Éco-PTZ",
    href: "/AidesFinancieresPage"
  }, {
    label: "CEE",
    href: "/AidesFinancieresPage"
  }, {
    label: "TVA réduite",
    href: "/AidesFinancieresPage"
  }, {
    label: "Simulation gratuite",
    href: "/AidesFinancieresPage"
  }];
  const entrepriseLinks = [{
    label: "À propos",
    href: "/HomePage"
  }, {
    label: "Espace Pro",
    href: "/EspaceProPage"
  }, {
    label: "Contact",
    href: "/ContactPage"
  }, {
    label: "En Urgence",
    href: "/EnUrgencePage"
  }];
  const socialLinks = [{
    icon: Facebook,
    href: "https://facebook.com/betravaux",
    label: "Facebook"
  }, {
    icon: Instagram,
    href: "https://instagram.com/betravaux",
    label: "Instagram"
  }, {
    icon: Linkedin,
    href: "https://linkedin.com/company/betravaux",
    label: "LinkedIn"
  }, {
    icon: Twitter,
    href: "https://twitter.com/betravaux",
    label: "Twitter"
  }];
  return <footer className="relative bg-dark-background text-foreground-dark">
      <div className="absolute top-0 left-0 right-0 h-1 bg-secondary" />
      
      <div className="max-w-7xl mx-auto px-6 py-16 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-8">
          <div ref={col1Ref} className="transition-opacity duration-700 ease-out" style={{
          opacity: col1Visible ? 1 : 0
        }}>
            <h3 className="text-lg font-display font-semibold mb-6 text-foreground-dark">
              Nos Services
            </h3>
            <nav className="flex flex-col gap-3">
              {servicesLinks.map((link, i) => <Link key={i} to={link.href} className="text-foreground-dark/80 hover:text-foreground-dark transition-colors duration-200 text-sm" data-index={i}>
                  {link.label}
                </Link>)}
            </nav>
          </div>

          <div ref={col2Ref} className="transition-opacity duration-700 ease-out delay-150" style={{
          opacity: col2Visible ? 1 : 0
        }}>
            <h3 className="text-lg font-display font-semibold mb-6 text-foreground-dark">
              Aides Financières
            </h3>
            <nav className="flex flex-col gap-3">
              {aidesLinks.map((link, i) => <Link key={i} to={link.href} className="text-foreground-dark/80 hover:text-foreground-dark transition-colors duration-200 text-sm" data-index={i}>
                  {link.label}
                </Link>)}
            </nav>
          </div>

          <div ref={col3Ref} className="transition-opacity duration-700 ease-out delay-300" style={{
          opacity: col3Visible ? 1 : 0
        }}>
            <h3 className="text-lg font-display font-semibold mb-6 text-foreground-dark">
              Be Travaux
            </h3>
            <nav className="flex flex-col gap-3">
              {entrepriseLinks.map((link, i) => <Link key={i} to={link.href} className="text-foreground-dark/80 hover:text-foreground-dark transition-colors duration-200 text-sm" data-index={i}>
                  {link.label}
                </Link>)}
            </nav>
            <div className="mt-8 text-sm text-foreground-dark/70">
              <p>49 impasse des lauriers</p>
              <p>83 600 Les Adrets de l'Esterel</p>
              <p className="mt-3">+33 6 32 41 41 20</p>
              <p>contact@betravaux.com</p>
            </div>

            <div className="mt-6">
              <h4 className="text-sm font-semibold mb-4 text-foreground-dark">
                Suivez-nous
              </h4>
              <div className="flex gap-4">
                {socialLinks.map((social, i) => {
                const Icon = social.icon;
                return <Link key={i} to={social.href} newTab className="text-foreground-dark/80 hover:text-foreground-dark transition-colors duration-200" aria-label={social.label} data-index={i}>
                      <Icon className="w-6 h-6" />
                    </Link>;
              })}
              </div>
            </div>
          </div>
        </div>

        <Separator className="my-8 bg-foreground-dark/20" />

        <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-foreground-dark/60">
          <p>&copy; {new Date().getFullYear()} Be Travaux. Tous droits réservés.</p>
          <div className="flex gap-6">
            <Link to="/mentions-legales/" className="hover:text-foreground-dark transition-colors duration-200">
              Mentions légales
            </Link>
            <Link to="/politique-de-confidentialite/" className="hover:text-foreground-dark transition-colors duration-200">
              Politique de confidentialité
            </Link>
          </div>
        </div>
      </div>
    </footer>;
}